import { ReactElement } from 'react';
export const Loader = (): ReactElement => {
  return <div className="loader" />;
};
